import GestaoAtendimentoAssisTecPage from "../../Atendimentos";

export default function GrupoAtendimentos() {
    return <GestaoAtendimentoAssisTecPage atendimento="USUARIO" />;
}
